module.exports = __webpack_public_path__ + "media/images/Icon-history-done-0bde749ea1a4bb402bd36e14b2c8d1a6.svg";